import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g fill="none" fillRule="evenodd" transform="translate(2)">
      <path fill="#F04E98" d="M0,32 L28,32 L28,20 L21.535,13.535 C19.583,11.583 16.417,11.583 14.465,13.535 L0,28 L0,32 Z"/>
      <path className="euiIcon__fillNegative" d="M14.4648,13.5352 L10.9288,17.0712 C12.7378,18.8812 15.2378,20.0002 17.9998,20.0002 C20.7618,20.0002 23.2618,18.8812 25.0708,17.0712 L21.5348,13.5352 C19.5828,11.5832 16.4168,11.5832 14.4648,13.5352"/>
      <path fill="#FEC514"
            d="M12.3428,11.4141 C13.8548,9.9031 15.8638,9.0711 17.9998,9.0711 C20.1368,9.0711 22.1458,9.9031 23.6568,11.4141 L26.8638,14.6211 C27.5858,13.2381 27.9998,11.6681 27.9998,10.0001 C27.9998,4.4771 23.5228,0.0001 17.9998,0.0001 C12.4778,0.0001 7.9998,4.4771 7.9998,10.0001 C7.9998,11.6681 8.4138,13.2381 9.1368,14.6211 L12.3428,11.4141 Z"/>
    </g>
  </svg>
);
